import classnames from 'classnames';
import ContentLoader from 'components/content/ContentLoader';
import { EnvironmentTypes } from 'helper/types';
import { useGetSystemVersion } from 'hooks/useGetSystemVersion';

import './_styles.scss';

const BrandLabel = () => {
    const { systemVersion, isFethingSystemVersion, environment } = useGetSystemVersion();

    const isAllowedEnvironment =
        environment === EnvironmentTypes.PRODUCTION || environment === EnvironmentTypes.PREPROD;

    return (
        <div
            id='brand-label'
            data-testid='brand-label'
            className={classnames('BrandLabel', {
                'BrandLabel--isAllowed': isAllowedEnvironment,
                'BrandLabel--isLoading': isFethingSystemVersion,
            })}
        >
            <p className='BrandLabel__label'>{'Control Center'}</p>
            {isFethingSystemVersion ? (
                <div data-testid='brand-label-version-skeleton' className='BrandLabel__skeleton'>
                    <ContentLoader height='20px' width='70px' />
                </div>
            ) : (
                <p data-testid='brand-label-version' className='BrandLabel__version'>
                    {systemVersion}
                </p>
            )}
        </div>
    );
};

export default BrandLabel;
